import React from "react";
import { sectionsSkippedByBlocks } from "./testOutRules";

// Editor-only note on the section that holds a test-out quiz. It lists the given
// sections, so a linked section outside them isn't named here.
function TestOutSkipsNote({ blocks, sections }) {
  const names = sectionsSkippedByBlocks(blocks, sections);
  if (names.length === 0) return null;

  return (
    <div className="mx-8 mb-4 px-4 py-3 rounded-lg bg-violet-50 text-sm text-violet-900">
      <span className="font-semibold">Passing skips:</span> {names.join(", ")}
    </div>
  );
}

export default TestOutSkipsNote;
